export default __webpack_public_path__ + "static/media/arrow_90_down.8286e533.svg";